'use strict';

exports.__esModule = true;
exports.setters = undefined;

var _setters;

var _Identifiers = require('./Identifiers');

var _Props = require('./Props');

var _Props2 = _interopRequireDefault(_Props);

var _Validators = require('./Validators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setters = exports.setters = (_setters = {}, _setters[_Identifiers.GENERAL_IDENTIFIERS.LINK] = function (tag, value, enableValidation) {
  var validator = { isValid: true };
  if (enableValidation) {
    validator = (0, _Validators.validateFullUrl)(value);
  }
  if (validator.isValid) {
    tag.props[_Props2.default.HREF] = value;
  }
  return validator;
}, _setters[_Identifiers.GENERAL_IDENTIFIERS.OG_META] = function (tag, value) {
  tag.props[_Props2.default.CONTENT] = value;
  return { isValid: true };
}, _setters[_Identifiers.GENERAL_IDENTIFIERS.STANDARD_META] = function (tag, value) {
  tag.props[_Props2.default.CONTENT] = value;
  return { isValid: true };
}, _setters);